module.exports = __webpack_public_path__ + "static/media/economics_and_finance.b7b0bd2e.png";